var map = {
	"./banner-home.jpeg": "c271",
	"./benefits/13.svg": "a3b4",
	"./benefits/99icons/13.svg": "5c16",
	"./benefits/99icons/academia.svg": "a272",
	"./benefits/99icons/alimentacao.svg": "678e",
	"./benefits/99icons/bike.svg": "e788",
	"./benefits/99icons/bolsa-auxilio.svg": "c108",
	"./benefits/99icons/bolsa.svg": "8140",
	"./benefits/99icons/desconto.svg": "b899",
	"./benefits/99icons/estacionamento.svg": "51dc",
	"./benefits/99icons/fretado.svg": "1e03",
	"./benefits/99icons/horario.svg": "f7cc",
	"./benefits/99icons/linguas.svg": "cd47",
	"./benefits/99icons/money.svg": "b15f",
	"./benefits/99icons/odonto.svg": "9bc6",
	"./benefits/99icons/previdencia.svg": "b5a1",
	"./benefits/99icons/sale.svg": "d258",
	"./benefits/99icons/saude.svg": "d75e",
	"./benefits/99icons/seguro.svg": "ed66",
	"./benefits/99icons/universidade.svg": "39ac",
	"./benefits/99icons/vale.svg": "fe92",
	"./benefits/99icons/vr.svg": "6f4f",
	"./benefits/academia.svg": "fcf7",
	"./benefits/alimentacao.svg": "8798",
	"./benefits/bike.svg": "bf77",
	"./benefits/bolsa-auxilio.svg": "5489",
	"./benefits/bolsa.svg": "622e",
	"./benefits/desconto.svg": "043e",
	"./benefits/estacionamento.svg": "9491",
	"./benefits/fretado.svg": "cf26",
	"./benefits/horario.svg": "d8f9",
	"./benefits/linguas.svg": "87a6",
	"./benefits/money.svg": "c746",
	"./benefits/odonto.svg": "b80a",
	"./benefits/previdencia.svg": "608c",
	"./benefits/saude.svg": "82c0",
	"./benefits/seguro.svg": "fc47",
	"./benefits/universidade.svg": "1828",
	"./benefits/vale.svg": "6fd1",
	"./benefits/vr.svg": "eeb8",
	"./bg-diversidade.jpg": "e0af",
	"./bg-rounded.png": "5943",
	"./capa-video-1.jpg": "99fb",
	"./capa-video-2.jpg": "745c",
	"./chevron-down.png": "0fc3",
	"./culture/cover.jpg": "a5e6",
	"./facebook-icon.png": "2d6d",
	"./hero-shape.png": "f0fe",
	"./how-we-hire/cover.jpg": "5f63",
	"./instagram-icon.png": "d3cb",
	"./linkedin-icon.png": "8ea4",
	"./logo-1.png": "6fd8",
	"./logo-2.png": "898d",
	"./logo-3.png": "2879",
	"./logo-4.png": "451a",
	"./logo-5.png": "3dd7",
	"./logo-blue-2.jpg": "58cf",
	"./logo-blue.png": "e43a",
	"./logo-powered-2.png": "8ab9",
	"./logo-powered.png": "16ca",
	"./logo-talentos-na-pista.svg": "b4f5",
	"./logo-white.png": "06f1",
	"./logo.png": "9d64",
	"./lu-chat.png": "7691",
	"./magalu-carreiras-white.png": "27ae",
	"./magalu-carreiras.png": "f61a",
	"./magazine-luiza-white.png": "955e",
	"./ok-check.svg": "0e2e",
	"./pen-white.svg": "28e7",
	"./pen.svg": "800f",
	"./question.svg": "fe82",
	"./teams/atendimento/atendimento-cover.jpg": "88bb",
	"./teams/atendimento/atendimento-thumb.jpg": "8954",
	"./teams/banco-talentos/banco-cover.png": "3baf",
	"./teams/banco-talentos/banco-talentos.png": "7c3b",
	"./teams/epoca-cosmeticos/epoca-cosmeticos-cover.jpg": "ab60",
	"./teams/epoca-cosmeticos/epoca-cosmeticos-thumb.jpg": "089e",
	"./teams/escritorios/escritorios-cover.jpg": "f85c",
	"./teams/escritorios/escritorios-thumb.jpg": "ba42",
	"./teams/estante-virtual/estante-virtual-cover.jpg": "1a56",
	"./teams/estante-virtual/estante-virtual-thumb.jpg": "1a4b",
	"./teams/jovens-talentos/estagio-cover.jpg": "9794",
	"./teams/jovens-talentos/estagio-thumb.jpg": "5633",
	"./teams/jovens-talentos/jovem-aprendiz-cover.jpg": "6950",
	"./teams/jovens-talentos/jovem-aprendiz-thumb.jpg": "5f7f",
	"./teams/jovens-talentos/jovens-talentos-cover.jpg": "899e",
	"./teams/jovens-talentos/jovens-talentos-thumb.jpg": "d983",
	"./teams/jovens-talentos/trainee-cover.jpg": "c5c9",
	"./teams/jovens-talentos/trainee-thumb.jpg": "f74c",
	"./teams/kabum/COMERCIAL-thumb.png": "19dd",
	"./teams/kabum/COMPRAS-INDIRETAS-thumb.png": "4837",
	"./teams/kabum/CUSTOMER-EXPERIENCE-thumb.png": "fca2",
	"./teams/kabum/ENGENHARIA-thumb.png": "890c",
	"./teams/kabum/ESPORTS-thumb.png": "d207",
	"./teams/kabum/FINANCEIRO-thumb.png": "ef00",
	"./teams/kabum/FISCAL-thumb.png": "1c77",
	"./teams/kabum/GOVERNANCA-CORPORATIVA-thumb.png": "b1ba",
	"./teams/kabum/JURIDICO-thumb.png": "0580",
	"./teams/kabum/LOGISTICA-thumb.png": "ff9a",
	"./teams/kabum/MANUTENCAO-thumb.png": "d6ef",
	"./teams/kabum/MARKETING-thumb.png": "a340",
	"./teams/kabum/MARKETPLACE-thumb.png": "896f",
	"./teams/kabum/MEIOS-DE-PAGAMENTO-thumb.png": "f1b2",
	"./teams/kabum/PLANEJAMENTO-COMERCIAL-thumb.png": "cf99",
	"./teams/kabum/PRIVATE-LABEL-thumb.png": "a4da",
	"./teams/kabum/PROJETOS-thumb.png": "233a",
	"./teams/kabum/RECURSOS-HUMANOS-thumb.png": "26b5",
	"./teams/kabum/TI-thumb.png": "c163",
	"./teams/kabum/TRANSPORTES-thumb.png": "9ff1",
	"./teams/kabum/UX-thumb.png": "a6f3",
	"./teams/kabum/kabum-cover.jpeg": "544d",
	"./teams/kabum/kabum-thumb.png": "8a68",
	"./teams/labs/agile-cover.jpg": "9e8a",
	"./teams/labs/agile-thumb.jpg": "b007",
	"./teams/labs/desenvolvedor-cover.jpg": "e511",
	"./teams/labs/desenvolvedor-thumb.jpg": "1176",
	"./teams/labs/labs-cover.jpg": "5d96",
	"./teams/labs/labs-thumb.jpg": "01f8",
	"./teams/labs/outros-thumb.jpg": "66b5",
	"./teams/labs/po-cover.jpg": "8f0a",
	"./teams/labs/po-thumb.jpg": "b586",
	"./teams/logistica/1.jpg": "7827",
	"./teams/logistica/2.jpg": "d570",
	"./teams/logistica/3.jpg": "aec2",
	"./teams/logistica/logistica-cover.jpg": "777d",
	"./teams/logistica/logistica-thumb.jpg": "544b",
	"./teams/loja/1.jpg": "0bba",
	"./teams/loja/2.jpg": "8474",
	"./teams/loja/3.jpg": "6daf",
	"./teams/loja/fintech-cover.jpg": "a856",
	"./teams/loja/fintech-thumb.jpg": "38b7",
	"./teams/loja/loja-cover.jpg": "e1e3",
	"./teams/loja/loja-thumb.jpg": "d79e",
	"./teams/netshoes/1.jpg": "463e",
	"./teams/netshoes/2.jpg": "8bc4",
	"./teams/netshoes/3.jpg": "f442",
	"./teams/netshoes/netshoes-cover.jpg": "8590",
	"./teams/netshoes/netshoes-thumb.jpg": "2586",
	"./test.svg": "46b0",
	"./tiktok-icon.png": "803e",
	"./twitter-icon.png": "5526",
	"./user-white.svg": "2fa0",
	"./user.svg": "c9d8",
	"./values/atitude-de-dono.jpg": "8ea3",
	"./values/cliente-em-primeiro-lugar.jpg": "7043",
	"./values/gente-que-gosta-de-gente.jpg": "dba7",
	"./values/mao-na-massa.jpg": "cbdb",
	"./values/resultado-sustentavel.jpg": "1d48",
	"./videos-cover/edilaine.jpg": "cb2d",
	"./videos-cover/entregas-ml-2019.jpg": "7ffb",
	"./videos-cover/valores-ml.jpg": "6819"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";